// extracted by mini-css-extract-plugin
export var carrierIcon = "_y4-0";
export var carrierLogo = "_y4-1";
export var detailsSection = "_y4-2";